import React, { Component } from "react";
import {
  getOfferListRequest,
  updateOfferStatusByOfferIdRequest,
  deleteOfferByOfferIdRequest,
} from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Switch from "react-switch";
import { makeOfferSelectField } from "store/OfferDetail/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import { confirmBox } from "helpers/messageHelper";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";
import CircularIconButton from "components/Buttons/CircularIconButton";

const columns = [
  {
    label: "Sequence",
    field: "offerSeq",
  },
  {
    label: "Image",
    field: "offerImage",
  },
  {
    label: "Offer Name",
    field: "offerName",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "disabled",
  },
];

class OfferList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offerRecords: [],
    };
  }

  componentDidMount() {
    //Retrieve offer list
    this.props.getOfferListRequest();
  }

  onStatusChange = (checked, e, id) => {
    this.props.updateOfferStatusByOfferIdRequest(id, checked);
  };

  buildOfferDataTable = (records) => {
    this.setState({
      offerRecords: records.map((offer) => {
        let imageView = (
          <img
            className="img-thumbnail"
            src={offer.offerImageUrl}
            alt={offer.offerName}
            width="150"
          />
        );

        let actions = (
          <div className="text-center">
            <CircularIconButton
              icon="far fa-edit fa-lg"
              onClick={this.viewOffer(offer)}
              tooltip={"Edit"}
            />

            <CircularIconButton
              icon="far fa-trash-alt fa-lg"
              onClick={this.deleteOffer(offer.offerDetailId)}
              tooltip={"Delete"}
            />
          </div>
        );

        let status = (
          <div className="d-flex">
            <Switch
              className="switch-sm"
              onColor={primaryColor}
              offColor={secondaryColor}
              onChange={(checked, e, id) => this.onStatusChange(checked, e, id)}
              id={offer.offerDetailId + ""}
              checked={offer.status ? true : false}
            />
            &nbsp;
          </div>
        );

        return {
          offerSeq: offer.offerSeq,
          offerImage: imageView,
          offerName: offer.offerName,
          status: status,
          actions: actions,
        };
      }),
    });
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (this.props.offerData !== nextprops.offerData) {
      this.buildOfferDataTable(nextprops.offerData);
    }
  }

  viewOffer = (offerData) => () => {
    this.props.onViewOffer(offerData);
  };

  deleteOffer = (offerDetailId) => async () => {
    const response = await confirmBox();
    if (response) {
      this.props.deleteOfferByOfferIdRequest(offerDetailId);
    }
  };

  render() {
    const data = {
      columns: columns,
      rows: this.state.offerRecords,
    };

    return (
      <React.Fragment>
        <CustomDataTable data={data} />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  offerData: makeOfferSelectField("offerData"),
});

const withConnect = connect(mapStatetoProps, {
  getOfferListRequest,
  updateOfferStatusByOfferIdRequest,
  deleteOfferByOfferIdRequest,
});

export default compose(withConnect, withRouter)(OfferList);
